import React from 'react';
import ReactMarkdown from 'react-markdown';

const WorkPage = () => {
    const markdownContent = 

` 
**Deployments @ [Bretton AI](https://www.bretton.com)**   
*October 2025 to Present - San Francisco, USA* 

- Helping build and deploy mission-critical automations for financial institutions, initially across financial crime investigations

**Business Operations @ [Meter](https://www.meter.com)**   
*February 2024 to October 2025 - San Francisco, USA* 

- Designed and built systems, tooling and processes for the channel distribution program
- Rebuilt critical components of quote-to-cash automations and designed financial operation flows
- Other activities: growth marketing metrics, influencer engagement programs, resale pricing models etc

**Engineering @ [Float Financial](https://www.floatcard.com)**   
*April 2022 to August 2022 - Toronto, Canada* 

- Built across the stack as an intern: microservices, UI components, data investigations, etc
    - Helped write multi-currency card issuing and authornization flows to expand interchange margins
    - Helped write fradulent transaction filters to prevent [BIN attacks](https://stripe.com/resources/more/what-are-bin-attacks-heres-what-businesses-should-know)
- Other activities: roadmap prioritization, handled customer issues, internal tooling

**Logistics @ [HackWestern](https://www.hackwestern.com/)**   
*July 2022 to March 2023 - London, Canada* 
  
- Led the planning, organization and operation of a 400+ person IRL hackathon at Western University
- Co-led a team with a $60k budget to coordinate logistics: food, security and transportation

**Investments @ [Front Row Ventures](https://frontrow.ventures/)**   
*May 2020 to April 2022 - Toronto, Canada* 
  
- Led a team of 10 student investors to perform due diligence and hold investment decision meetings
- Met with founders, researched industries, wrote deal memos and led the funding of 2 startups

**Data Science @ TD Bank**   
*June 2019 to August 2019 - Toronto, Canada* 
  
- Analyzed +700m payments data points with unsupervised machine learning techniques as an intern
- Presented findings to senior executives on customer churn, leading to $2mm in savings

-----

**BESc. Software Engineering @ Western University**   
*September 2019 to June 2023 - London, Canada* 
`;
  
    return (
      <div>
        <ReactMarkdown>{markdownContent}</ReactMarkdown>
      </div>
    );
  };

export default WorkPage
  
